import React from 'react';
import { ReactComponent as UploadIcon } from "../../styles/icon/upload.svg";
import { ReactComponent as SelectIcon } from "../../styles/icon/select-file.svg";
import Button from "../../elements/Button/Button";
import styles from './CertificateUpload.module.scss';
import strings from '../../lang/lang';

const CertificateUploadFile = () => {
  return (
    <div className={styles.certificate_upload__file}>
      <div className={styles.certificate_upload__file_box}>
        <div className={styles.certificate_upload__file_icon}>
          <UploadIcon />
        </div>
        <div className={styles.certificate_upload__file_desc}>{strings.certificateUploadFile.text.description}</div>
      </div>
      <Button
        name={strings.certificateUploadFile.buttons.select}
        variant="primary"
        secondaryClassName="popup_primary"
      >
        <SelectIcon />
      </Button>
    </div>
  )
};

export default CertificateUploadFile;
